import { render, staticRenderFns } from "./TeminatForm.vue?vue&type=template&id=2545f606"
import script from "./TeminatForm.vue?vue&type=script&lang=ts"
export * from "./TeminatForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports